import TypeValueRepository from "@/repositories/dexpara/Type/TypeValueRepository";
import makeStore from "@/storages/Base/Storage";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

const store = makeStore('value', TypeValueRepository);

export default {
    ...store,
    state: {
        ...makeState(),
        listTypeValues: []
    },
    getters: {
        ...makeGetters(),
        allTypeValues(state) {
            return state.listTypeValues
        }
    },
    mutations: {
        ...makeMutations(),
        setAllTypeValues(state, array) {
            state.listTypeValues = array
        }
    },
    actions: {
        ...store.actions,
        async listAll({commit}, params) {
            commit('setLoading', true)
            await TypeValueRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.data)
                commit('setPagination', response.data.data)
            })
            commit('setLoading', false)
        },
        async findTypeValues ({ commit }, params) {
            commit('setLoading', true)
            await TypeValueRepository.findByFilter(params).then(response => {
                commit('setAllTypeValues', response.data)
            })
            commit('setLoading', false)
        }
    }
}